import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/angular-material/angular-material.module';

@Component({
  selector: 'dxf-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  imports: [
    FormsModule,
    AngularMaterialModule,
    CommonModule
  ],
  standalone: true
})
export class ButtonComponent implements OnInit {

  @Input() type: 'primary' | 'secondary' | 'success' | 'error' | 'warning' | 'info' | 'dark' | 'light' | 'default' | 'newSuccess' | 'reminder' | 'dark-info' | 'black' | 'outline-primary';
  @Input() text: string;
  @Input() icon: string;
  @Input() id: string;
  @Input() textSize: string = 'sm';
  @Input() loading: boolean;
  @Input() textBold: boolean;
  @Input() shadow: boolean;
  @Input() disabled: boolean;
  @Input() asMenu: boolean = false;
  @Input() withRoundedCorners: boolean = true;
  @Input() isUppercase: boolean = false;
  @Input() keepCase: boolean = false;

  @Input() withSpinner: boolean = true;
  @Input() tooltip: string

  constructor() { }

  ngOnInit() {
  }

  get buttonName(): string {
    if (!this.text) return '';
    if (this.keepCase) return this.text;
    if (this.text && this.isUppercase) return this.text.toUpperCase();

    return this.text[0].toUpperCase() + this.text.substring(1).toLowerCase();
  };
}
